import {DatePicker, Select, Space} from "antd";
import useControlValue from "@kne/use-control-value";
import dayjs from "dayjs";
import {useIntl} from "@kne/react-intl";
import withLocale from "../withLocale";

const TypeDatePickerField = ({...props}) => {
    const {formatMessage} = useIntl();
    const typeList = new Map([["date", formatMessage({id: "customTime"})], ["month", formatMessage({id: "monthly"})], ["week", formatMessage({id: "weekly"})],]);
    const [value, onChange] = useControlValue(props);
    return (<Space.Compact>
        <Select
            style={{width: "120px"}}
            value={value?.type || "date"}
            onChange={(typeValue) => {
                onChange((value) => {
                    if (!value?.value?.length) {
                        return {value: null, type: typeValue || "date"};
                    }
                    const startTime = dayjs(value.value[0]), endTime = dayjs(value.value[1]);
                    return {
                        value: [startTime.isValid() ? startTime.startOf(typeValue || "date") : null, endTime.isValid() ? endTime.endOf(typeValue || "date") : null],
                        type: typeValue || "date",
                    };
                });
            }}
            options={Array.from(typeList).map(([value, label]) => ({
                label, value,
            }))}
        />
        <DatePicker.RangePicker
            {...props}
            picker={value?.type || "date"}
            value={Array.isArray(value?.value) && value.value.length === 2 && value.value.map((item) => item && dayjs(item))}
            onChange={(dateValue) => {
                onChange((value) => {
                    console.log(Object.assign({type: "date"}, value, {
                        value: dateValue && [dateValue[0] && new Date(dateValue[0].startOf(value?.type || "date").valueOf()), dateValue[1] && new Date(dateValue[1].endOf(value?.type || "date").valueOf()),],
                    }));
                    return Object.assign({type: "date"}, value, {
                        value: dateValue && [dateValue[0] && new Date(dateValue[0].startOf(value?.type || "date").valueOf()), dateValue[1] && new Date(dateValue[1].endOf(value?.type || "date").valueOf()),],
                    });
                });
            }}
        />
    </Space.Compact>);
};

export default withLocale(TypeDatePickerField);
